module.exports = __webpack_public_path__ + "img/icon-minus-blue.82987f8a.svg";